<app-layer-button
  class="position-absolute bottom-7 start-5 z-2"
  (visibilityToggled)="toggleLayerSwitchVisibility()"
>
</app-layer-button>

<div class="position-absolute bottom-20 start-5 z-2 pt-2" [class.d-none]="!isLayerSelectionVisible">
  <app-layer-config (closed)="close()">
    <div class="d-flex flex-column categories">
      <app-layer-config-collapsible-category
        class="border-bottom border-darkgray"
        description="Filters"
        storageKey="customer-filters"
        data-cy="customer-filters-category"
      >
        <div class="customer-filters">
          <div class="customer-filters__row">
            <span class="customer-filters__label">temporary content only</span>
            <label class="customer-filters__switch" data-cy="customer-filters-switch">
              <input
                class="customer-filters__switch-input"
                type="checkbox"
                [checked]="isInCSFilterMode"
                (change)="toggleIsInCSFilter()"
                aria-label="Toggle construction site signs filter"
              />
              <span class="customer-filters__switch-track">
                <span class="customer-filters__switch-thumb"></span>
              </span>
            </label>
          </div>
        </div>
      </app-layer-config-collapsible-category>

      <app-rollouts-tile-data> </app-rollouts-tile-data>
    </div>
  </app-layer-config>
</div>
